module.exports = __webpack_public_path__ + "img/stars.ec57d34.png";